import { render, staticRenderFns } from "./StudentsToPartnersModal.vue?vue&type=template&id=49665953&"
import script from "./StudentsToPartnersModal.vue?vue&type=script&lang=js&"
export * from "./StudentsToPartnersModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsToPartnersModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports